var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBottomLeftArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6402 1.15495C10.8599 0.935281 10.8599 0.579126 10.6402 0.359456C10.4205 0.139786 10.0644 0.139786 9.84472 0.359456L1.87337 8.33081C1.85152 8.2396 1.83343 8.1322 1.8194 8.00369C1.77621 7.60826 1.77768 7.08916 1.78105 6.33363L1.78935 4.47202C1.79074 4.16137 1.54003 3.90841 1.22937 3.90702C0.918712 3.90563 0.665751 4.15635 0.664365 4.46701L0.655909 6.36215C0.652712 7.07593 0.650099 7.6593 0.701046 8.12582C0.754024 8.61095 0.8707 9.04045 1.15672 9.41003C1.28213 9.57208 1.42759 9.71754 1.58964 9.84295C1.95923 10.129 2.38873 10.2457 2.87385 10.2986C3.34037 10.3496 3.92373 10.347 4.63751 10.3438L6.53267 10.3353C6.84333 10.3339 7.09404 10.081 7.09265 9.77031C7.09127 9.45965 6.83831 9.20894 6.52765 9.21032L4.66604 9.21863C3.91052 9.222 3.39141 9.22346 2.99598 9.18028C2.86747 9.16625 2.76007 9.14816 2.66887 9.1263L10.6402 1.15495Z",
    fill: "#06D6A0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBottomLeftArrow);
export default __webpack_public_path__ + "static/media/bottom-left-arrow.0e645618276545f13dd4ca1b6a8ea7c0.svg";
export { ForwardRef as ReactComponent };